module.exports = __webpack_public_path__ + "img/product_anevil.7f0a589b.jpg";